import { Box, Button, Stack, Tooltip } from '@mui/material'
import BlockIcon from '@mui/icons-material/Block'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'
import { InfoMensajeDesktop } from '../../../components/desktop/InfoMensajeDesktop'
import { HeaderProps } from '../../OperacionLayout'
import { MensajeDetalleFields } from 'src/pages/messages/types'

const permiteAnular = (value: unknown) => value === true || value === 1 || value === '1' || value === 'true'

export const HeaderDesktop = ({ acciones, message }: HeaderProps) => {
    const { cancelHandler, closeHandler, printHandler } = acciones
    const puedeAnular =
        permiteAnular(message[MensajeDetalleFields.PermiteAnular]) ||
        permiteAnular(message[MensajeDetalleFields.PermiteAnularAlias])
    const puedeDescargarInforme = !!printHandler

    return (
        <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            maxWidth='100%'
            pb={6}
        >
            <InfoMensajeDesktop message={message} />
            <Stack direction='row' spacing={2}>
                {puedeDescargarInforme && printHandler && (
                    <Tooltip title='Descargar'>
                        <Button variant='outlined' color='primary' startIcon={<DownloadIcon />} onClick={printHandler}>
                            Descargar
                        </Button>
                    </Tooltip>
                )}
                {puedeAnular && (
                    <Tooltip title='Anular'>
                        <Button variant='outlined' color='error' startIcon={<BlockIcon />} onClick={cancelHandler}>
                            Anular
                        </Button>
                    </Tooltip>
                )}
                <Tooltip title='Cerrar'>
                    <Button variant='contained' onClick={closeHandler} color='primary' startIcon={<CloseIcon />}>
                        Cerrar
                    </Button>
                </Tooltip>
            </Stack>
        </Box>
    )
}
